export const NET_ID_KE = "KE"
export const NET_ID_SF = "SF"
export const NET_DEFAULT = "DEFAULT"

export const LAT_INIT = 47.5036464
export const LNG_INIT = 10.2782242

// Default zoom level if none was rememberd
export const ZOOM_INIT = 10

// Minimum zoom level (how far you can go to space)
export const ZOOM_MIN = 10

// Maximum zoom level (how close can you get)
// Values higher than 18 are NOT supported by the backend.
export const ZOOM_MAX = 18

// Default zoom level for GenericBackendManager when creating entries
// using the map context menu
export const ZOOM_GEO_CREATE = 16
